import * as React from 'react'

import './index.styles.css'
interface Props {
  d: string | null
}

const Link: React.FC<Props> = ({ d }) => {
  if (!d) return null

  return <path className={'Link_link'} d={d} />
}

export default Link
